import { Menu, MenuItem } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { updateTab } from "../../features/project";

function PostSortingLabel({tab}){
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const setMode = newMode => {
        handleClose();

        dispatch(updateTab({
            id: tab.id,
            filters: {
                ...(tab.config.filters || {}),
                viewMode: newMode,
                orderBy: newMode === "engagement" ? "engagement" : "post_timestamp"
            }
        }));
    }
  
    const filters = tab.config.filters || {};
    const orderBy = filters.orderBy;
    const viewMode = filters.viewMode || (orderBy === "engagement" ? "engagement" : "date");
    const splitSwap = !!filters.splitSwap;
    const label = viewMode === "engagement" ? "engagement" : (viewMode === "split" ? "Split View" : "date");
    const descriptor = viewMode === "engagement"
        ? "most popular first"
        : viewMode === "split"
            ? (splitSwap ? "top engagement + recent" : "recent + top engagement")
            : "newest first";
    return <>
        <span
            aria-controls={open ? 'sort-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            className="link">
                {label}
        </span>
        , {descriptor}
        <Menu
            id="sort-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuItem onClick={() => setMode("date")}>Date</MenuItem>
            <MenuItem onClick={() => setMode("engagement")}>Engagement</MenuItem>
            <MenuItem onClick={() => setMode("split")}>Split View (beta)</MenuItem>
        </Menu>

    </>
}

export default PostSortingLabel;